import {gql} from 'apollo-angular';
import {ImageFragment} from "./fragments/Image";

export const GET_ROOKIE_OFFER_TIME_SLOT_MAPPING = gql`
  query RookieOfferTimeSlotMappingById($offerTsMappingId: Int!) {
    rookieOfferTimeSlotMappingById(offerTsMappingId: $offerTsMappingId) {
      id
      shortCode
      remainingSlots
      provider {
        id
        uuid
        name
        description

        companyBenefits {
          id
          name
        }

        locations {
          id
          name
          address {
            street
            number
            addressCity {
              id
              name
              zip
            }
          }
        }
        companyProfilePicture {
          id
          name
          image {
            ...imageFields
          }
        }
      }
      workTime
      workClothes
      timeSlot {
        id
        openAt
        closeAt
        workFrom
        workTo
        schools {
          id
          schoolName
        }
      }
      job {
        id
        bicID
        name
        description
        videoUrl
        jobSalary {
          entries {
            salaryType
            salaryFrom
            salaryTo
          }
        }
        scholasticDuration {
          durationName
          position
        }
        interestFields {
          id
          interestName
        }
      }
      additionalEntries {
        id
        remainingSlots
        job {
          id
          name
        }
        provider {
          id
          uuid
          name
          locations {
            id
            name
            address {
              street
              number
              addressCity {
                id
                name
              }
            }
          }
          companyProfilePicture {
            id
            name
            image {
              ...imageFields
            }
          }
        }

        timeSlot {
          id
          openAt
          closeAt
          workFrom
          workTo
        }
      }
    }
  }
  ${ImageFragment}
`;
